import React from 'react';
import {FormField, Slider} from 'components';
import {includes, pluralize, useFocusPopup, useField} from 'helpers';

export function TimesPerDay({ allow }) {
  const [ { value }, , { setValue } ] = useField('repetition');
  const field = value.repeatType == 'PerDay' ? 'repeatCount' : 'repeatCountPerDay';
  const popup = useFocusPopup(TimesPerDaySlider, {
    field,
    name: 'repetition',
    className: 'adjacent',
    value,
    setValue,
    deps: [ value ],
  });
  return includes(allow, 'dayFrequency') && Boolean(value.repeatType) && (
    <FormField label="Frequency" value {...popup}>
      <b>{ value[field] || 1 } { pluralize('time', value[field]) } / day</b>
    </FormField>
  );
}

function TimesPerDaySlider({ field, value, setValue }) {
  return (
    <Slider min={1} max={12} value={value[field] || 1} setValue={number => setValue({ ...value, [field]: number })} options filled />
  );
}
